export default "__VITE_ASSET__cgm3Xydo__"